module.exports = __webpack_public_path__ + "media/images/flags/im-a2cdfa4ee5eeed3ba4ec6fba26989a2b.svg";